'use strict';exports.__esModule = true;exports.checkIfShouldRequestLocus = exports.isLocalStorageAvailable = exports.isTemporaryEmail = exports.isUserAuthorized = exports.isMobileDisplaySize = undefined;var _constants = require('../constants');

var MOBILE_PIXEL_BREAKPOINT = 768;

var isMobileDisplaySize = exports.isMobileDisplaySize = function isMobileDisplaySize(displayWidth) {return displayWidth < MOBILE_PIXEL_BREAKPOINT;};

var isUserAuthorized = exports.isUserAuthorized = function isUserAuthorized(nextState, replace) {
  if (global && _constants.storage.value) {
    var userData = _constants.storage.value.getItem('userData');
    if (!userData || !JSON.parse(userData).access_token) {
      replace('/');
    }
  }
};

var isTemporaryEmail = exports.isTemporaryEmail = function isTemporaryEmail(email) {return email && typeof email === 'string' && email.endsWith(_constants.temporaryEmailEnding);};

var isLocalStorageAvailable = exports.isLocalStorageAvailable = function isLocalStorageAvailable() {
  try {
    global.localStorage.setItem('test', 'test');
    global.localStorage.removeItem('test');
    return true;
  } catch (exception) {
    return false;
  }
};

var ADDRESS_EXCEPTIONS = ['ariel', 'ari\'el', 'ari`el', 'אריאל', 'avnei hefetz', 'אבני חפץ', 'מעלה אדומים', 'maale adumim', 'ma\'ale adumim'];
var checkIfShouldRequestLocus = exports.checkIfShouldRequestLocus = function checkIfShouldRequestLocus(value) {
  var comparedValue = value.toLowerCase();
  return ADDRESS_EXCEPTIONS.includes(comparedValue);
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/checkers.js
// module id = 65
// module chunks = 0